import Component from '@cx-modules/offers-slim';
import OffersSlimCss from '@cx-modules/offers-slim/style.css?inline';
import {
  widgetBootstrap,
  fetchCampaignData
} from '../../services/cx-module-helper';
import { contract } from './contract.js';
import themes from './themes';
import themeContract from './themes/contract';
import { slimBaseStyles } from './base-styles.js';

export const attributes = [
  'placeholders',
  'disable-analytics',
  'geotargeting',
  'autohide-terms',
  'z-index-patch'
];

export const widgetName = 'oc-offers-slim-widget';

const fetchCampaign = async attr => {
  const data = await fetchCampaignData(attr.slotId, attr.overrideUrl);
  return {
    ...data,
    variantType: 'slot',
    idForCxCache: data.hash
  };
};

widgetBootstrap({
  attributes,
  Component,
  contract,
  customCss: slimBaseStyles,
  fetchCampaign,
  name: widgetName,
  style: OffersSlimCss,
  themes,
  themeContract,
  version: '1.0.0'
});
